import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { history } from '../../';

import { isWidthDown } from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid';

import pushToGTM, { pageLoadGA4Tag } from '../../utils/analytics/gtm';
import { tabRoutes } from '../../routes';
import tabbarSlice from '../../components/Tabbar/tabbarSlice';
import { useStyles } from './styles';
import SidepanelLayout from '../SidepanelLayout';
import SummaryActionbar from '../../components/SummaryActionbar';
import InputParameters from '../../components/InputParameters';
import DesignSpecifications from '../../components/DesignSpecifications';
import BOMTable from '../../components/BomTable';
import OperatingValues from '../../components/OperatingValues';
import Charts from '../../components/Charts';
import DetailedSchematic from '../../components/DetailedSchematic';
import useFetchData from '../../hooks/useFetchData';
import ErrorPage from '../ErrorPage';
import { localView } from '../../utils/analytics/local';

const SummaryPage = ({ screenWidth }) => {
	const classes = useStyles();
	const [opValuesCategory, setOpValuesCategory] = useState('ALL');
	const disabledTabs = useSelector(state => state.tabbar.disabledTabs);
	const fetchDesignData = useSelector(state => state.selectedDesign.fetchDesignData);
	const inputParametersSD = useSelector(state => state.selectedDesign.detail.inputParameters);
	const initialVinNom = useSelector(state => state.selectedDesign.initialInputParameters.vinNom);
	const partNumber = useSelector(state => state.selectedDesign.detail.rankingParameters.partNumber);
	const progressActive = useSelector(state => state.tabbar.progressActive);
	const dispatch = useDispatch();

	const hasError = useFetchData(fetchDesignData, disabledTabs);

	useEffect(() => {
		if (disabledTabs.Summary) {
			if (disabledTabs.Select) {
				history.push(tabRoutes.find(route => route.name === 'Inputs').path);
			} else {
				history.push(tabRoutes.find(route => route.name === 'Select').path);
			}
		} else {
			if (!fetchDesignData) {
				localView('Summary', partNumber);
				pushToGTM(pageLoadGA4Tag('SUMMARY'));
				dispatch(tabbarSlice.actions.setProgressActive(false));
			}
		}
	}, [dispatch, disabledTabs, fetchDesignData]);

	if (!progressActive && hasError) {
		return <ErrorPage destinationPage={'Select'} />;
	}

	return (
		<SidepanelLayout
			sidepanel={
				<Grid
					container
					direction={screenWidth === 'sm' ? 'row' : 'column'}
					spacing={isWidthDown('sm', screenWidth) ? 2 : 3}>
					<Grid item container xs={screenWidth === 'sm' ? 6 : false}>
						<InputParameters inputParameters={inputParametersSD} isVinNomSet={initialVinNom !== ''} />
					</Grid>

					<Grid item container xs={screenWidth === 'sm' ? 6 : false}>
						<DesignSpecifications />
					</Grid>
				</Grid>
			}
			content={
				<Fragment>
					<SummaryActionbar />

					<DetailedSchematic page={'SUMMARY'} withTitle />

					<div className={classes.container}>
						<BOMTable />
					</div>

					<div className={classes.container}>
						<OperatingValues
							opValuesCategory={opValuesCategory}
							setOpValuesCategory={setOpValuesCategory}
							withTitle
							screenWidth={screenWidth}
							id="OperatingValues"
						/>
					</div>

					<div className={classes.container}>
						<Charts page={'SUMMARY'} withTitle screenWidth={screenWidth} />
					</div>
				</Fragment>
			}
		/>
	);
};

SummaryPage.propTypes = {
	screenWidth: PropTypes.number.isRequired
};

export default SummaryPage;
